import LaasImg from "public/pocCloud/lab-as-a-service.png";

export const INTRO_CONSTANTS = {
  title: "Lab-as-a-Service, Reimagined by OneMind",
  description: [
    "Unlock advanced IT lab environments—no hardware required. OneMind’s Lab-as-a-Service (LaaS) delivers fully managed, cloud-based labs designed for testing, training, development, and simulation. Whether you're validating network architectures, conducting hands-on IT training, or testing software at scale, we make it effortless.",
    "Eliminate infrastructure headaches and accelerate innovation with real-world lab experiences—delivered on demand.",
  ],
  points: [
    "Fully Managed Cloud Lab Infrastructure : Provision labs instantly with zero setup or maintenance overhead.",
    "On-Demand Scalability : Spin up training labs, dev/test environments, or simulations as needed.",
    "Cost-Effective & Realistic : Access enterprise-grade environments without capital investment—built for hands-on learning and experimentation.",
  ],
  image: LaasImg,
};
